import { DownloadOutlined, LoadingOutlined } from "@ant-design/icons";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import { getDownloadPack } from "../../../redux/Transcribe/TranscribeAction";
import { Spin, Tooltip } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

interface DownloadPackProps {
  id: number;
  status: string;
}

function DownloadPack(props: DownloadPackProps) {
  const dispatch = useAppDispatch();
  const loading = useSelector((state: RootState) => state.TranscribeState.getDownloadDataState.fileDownloadLoading);
  return (
    <Tooltip
      placement="bottom"
      title={"Download "}>
      <button
        className="button action"
        disabled={props.status === "NEW" || props.status === "FAILED"}
        onClick={() => {
          dispatch(getDownloadPack(props.id));
        }}>
        {loading ? (
          <Spin
            spinning={loading}
            indicator={
              <LoadingOutlined
                style={{ color: "white" }}
                spin
              />
            }
            size="small"
          />
        ) : (
          <DownloadOutlined style={{ fontSize: "20px", color: "white" }} />
        )}
      </button>
    </Tooltip>
  );
}

export default DownloadPack;
